export default __webpack_public_path__ + "static/media/icon-info-assetcard.6dbd87cb.svg";